import type { IEnglishIqV2StoredFlow } from '../english-iq-v2-stored-flow';
import { englishIqV2StoredFlowSchema } from '../english-iq-v2-stored-flow';
import { ENGLISH_IQ_V2_STORAGE_KEY } from './english-iq-v2-storage-key';

export function readEnglishIqV2StoredFlow(): IEnglishIqV2StoredFlow | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const raw = localStorage.getItem(ENGLISH_IQ_V2_STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const candidate = JSON.parse(raw) as { expiresAt?: unknown; view?: unknown };
    const isPartialExpired =
      candidate.view !== 'result' &&
      typeof candidate.expiresAt === 'number' &&
      candidate.expiresAt <= Date.now();
    if (isPartialExpired) {
      localStorage.removeItem(ENGLISH_IQ_V2_STORAGE_KEY);
      return null;
    }
    const parsed = englishIqV2StoredFlowSchema.safeParse(candidate);
    if (parsed.success) {
      return parsed.data as IEnglishIqV2StoredFlow;
    }
  } catch {}
  localStorage.removeItem(ENGLISH_IQ_V2_STORAGE_KEY);
  return null;
}
